import { apiClient } from '../client';
import type { ApiError } from '@/lib/types/errors';
import { err, ok, type Result } from '@/lib/types/result';

/**
 * Public dancer profile. The backend serves only handle, displayName and
 * createdAt for active, unsuspended dancers; every other account shape answers
 * 404 so this call cannot be used to probe whether an account exists.
 */
export interface PublicDancerProfile {
  handle: string;
  displayName?: string;
  createdAt: string;
}

export const getPublicProfile = async (
  handle: string
): Promise<Result<PublicDancerProfile, ApiError>> => {
  try {
    const response = await apiClient.get<PublicDancerProfile>(
      `/v2/u/${encodeURIComponent(handle)}`
    );
    if (!response.ok) {
      return err(response.error);
    }
    return ok(response.value);
  } catch {
    return err({ type: 'network', message: 'Failed to load profile' });
  }
};
